/**
 * Created by Jan Bradac on 3.1.2016.
 */

/**
 * Creates hash from jQuery object.
 *
 * TODO provide longer hash? Because with 32 bits there might be collisions...
 *
 * source: http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
 * TODO MOBA II - Replace with IdsGenerator and remove from PS.
 * @deprecated
 */

ObjectHashMaker = {
    getHash: function (jQueryObject) {
        var path = FullDomPathProvider.getFullDomPath(jQueryObject);
        return path.hashCode();
    }
};
